<template>
  <van-popup
    v-model="showPickupCode"
    :close-on-click-overlay="false"
    @click-overlay="clickClose"
    @close="clickClose">
    <div class="contain" @click="clickClose">
      <img class="img" src="" alt="提货码" fit="cover" />
    </div>
  </van-popup>
</template>

<script>
import { Popup } from "vant"

export default {
  name: "pickupCode",
  components: {
    [Popup.name]: Popup
  },
  props: {
    showPickupCode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    clickClose() {
      this.$emit("update:showPickupCode", false)
    }
  }
}
</script>

<style lang="less" scoped>
.contain {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .img {
    width: 150px;
    height: 150px;
  }
}
</style>
